import React from 'react'
import { Typography } from '@mui/material'
import { useWallboxLabel } from '../../shared/hooks/use-wallbox-label'

/**
 * Renders wallbox cell. Conditionally displays just the wallbox name in case this wallbox name is unique across all connected wallboxes.
 * Otherwise, it displays both the wallbox name and wallbox id to differentiate between two wallboxes.
 *
 * In case session was triggered on a wallbox which is no longer connected, just the wallbox id will be displayed.
 */
export const WallboxCell: React.FC<{
  wallboxId: string
}> = ({ wallboxId }) => {
  const { getWallboxLabel } = useWallboxLabel()
  const wallboxLabel = getWallboxLabel({ wallboxId })

  return <Typography variant="body2">{wallboxLabel}</Typography>
}
